// extracted by mini-css-extract-plugin
module.exports = {"page":"__125w-bifacial-modular-solar-panel_page__92LAq"};